import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../i18n.js";
import "../../css/signout/signout.css";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../App.js";
import axios from "axios";
import { SignoutRequest } from "./SignoutRequest.js";

function Signout({ theme, setOpenSignout }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [signoutButtonStatus, setSignoutButtonStatus] = useState(false);

  const [active, setActive] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setActive(true);
    }, 150);
  }, []);

  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setOpenSignout(false);
          }, 150);
        }}
      ></div>
      <div className={`popupMainDiv ${theme} ${active && "active"}`}>
        <div>{t("Do you want to signout of your account?")}</div>
        <button
          className={`submit_button ${theme}`}
          onClick={() => {
            setActive(false);
            setTimeout(() => {
              setOpenSignout(false);
            }, 150);
          }}
        >
          {t("Cancel")}
        </button>
        <button
          className={`submit_button ${theme} active`}
          onClick={() => {
            setSignoutButtonStatus(true);

            SignoutRequest(setSignoutButtonStatus);
          }}
        >
          {signoutButtonStatus ? (
            <img src="/icons/loading.png" className="icon rotate"></img>
          ) : (
            t("Signout")
          )}
        </button>
      </div>
    </>
  );
}

export default Signout;
